/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getSegmentsOverrides';
import type { GetSegmentsQueryParams } from '../../operation-overrides/getSegmentsOverrides';

export type GetSegmentsPathParams = NonNullable<operations['getSegments']['parameters']['path']>;
export type { GetSegmentsQueryParams };

export interface Input extends GetSegmentsPathParams {
  apiVersion?: string;
  query?: GetSegmentsQueryParams;
}

export async function getSegments(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/segments/{projectKey}/{environmentKey}', {
    params: {
      path,
      // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
      query,
    },
    // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
    querySerializer: overrides.querySerializer,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
